// hooks
import { useQuery } from 'react-query';
import { getRequestQualifications } from 'RestAPIs/employees/qualifications';

const useGetRequestQualifications = (
  { requestId },
  options: Record<string, any> = {}
) => {
  return useQuery(
    ['requestQualifications', requestId],
    async () => {
      const { data } = await getRequestQualifications(requestId);
      return data;
    },
    { ...options }
  );
};

export default useGetRequestQualifications;
